import wordpressJson from "./wordpress.json";
import type { ContentItem, ContentManifest } from "./types";

export const contentManifest = wordpressJson as ContentManifest;
export const contentItems = contentManifest.items;
export const articles = contentItems
  .filter((item): item is ContentItem & { type: "post" } => item.type === "post")
  .sort((left, right) => right.publishedAt.localeCompare(left.publishedAt));
export const legacyPages = contentItems.filter(
  (item): item is ContentItem & { type: "page" } => item.type === "page",
);

export function contentBySlug(slug: string): ContentItem | undefined {
  return contentItems.find((item) => item.slug === slug);
}

export function contentByPath(pathname: string): ContentItem | undefined {
  return contentItems.find((item) => item.canonicalPath === pathname);
}
